var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.65,
    height: 15.909,
    viewBox: "0 0 15.65 15.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "o7aafucw2a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3460",
    style: {
      fill: "none"
    },
    d: "M0 0h15.65v15.909H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1470",
    style: {
      clipPath: "url(#o7aafucw2a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 227",
    d: "m15.119 7.553-7.3 7.3-7.289-7.3",
    style: {
      stroke: "#1d1d1b",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1",
    transform: "translate(7.832)",
    style: {
      stroke: "#1d1d1b",
      strokeWidth: "1.5px",
      fill: "none"
    },
    d: "M0 13.772V0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.4214aadb333308f6bfeb85c8d0018714.svg";
export { ForwardRef as ReactComponent };